import Image from 'next/image'
import Link from 'next/link'
import s from './upgrade-product-card.module.css'
export default function UpgradeProductCard({
  product,
  onClose,
  inCart,
}: {
  product: any
  onClose: any
  inCart?: boolean
}) {
  const priceFormatter = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
  })
  const availableVariantEdges: any[] =
    product.variants?.edges?.filter((e: any) => e.node?.availableForSale) ?? []
  const inStockPrices = availableVariantEdges.map((e: any) =>
    Number(e.node.priceV2?.amount ?? 0)
  )
  const minPrice =
    inStockPrices.length > 0
      ? Math.min(...inStockPrices)
      : Number(product.priceRange?.minVariantPrice?.amount ?? 0)
  const maxPrice =
    inStockPrices.length > 0
      ? Math.max(...inStockPrices)
      : Number(product.priceRange?.maxVariantPrice?.amount ?? 0)
  const hasVariantPriceRange =
    minPrice !== undefined && maxPrice !== undefined && minPrice !== maxPrice
  const formattedPrice = priceFormatter.format(minPrice)
  return (
    <Link href={`/products/${product.handle}`} onClick={onClose}>
      <div key={product.id} className={s.upgradeProductCard}>
        <div className={s.imageContainer}>
          <Image
            src={product.images.nodes[0]?.url}
            alt={product.images.nodes[0]?.altText || product.name}
            width={75}
            height={75}
          />
        </div>
        <div className={s.productDetails}>
          <div className={s.title}>{product.title}</div>
          <div className={s.price}>
            {hasVariantPriceRange && (
              <span className="font-normal text-xs">from </span>
            )}
            {formattedPrice}
          </div>
          {inCart && <div className={s.inCartBadge}>In your cart</div>}
        </div>
      </div>
    </Link>
  )
}
